import FormBalance from "../components/FormBalance";
import { Container } from "@material-ui/core";
import logo from "../assets/logo.png";
import { Footer } from "../components/Footer";
import { useState } from "react";
import { postData } from "../api/postData";
import Alert from "@material-ui/lab/Alert";
import Amount from "../components/Amount";

export const Home = () => {
  const [error, setError] = useState("");
  const [data, setData] = useState(null);

  const handleSubmit = async (dataForm) => {
    setError("");
    const dataCopy = { ...dataForm };

    delete dataCopy.recaptcha;

    const res = await postData(dataCopy, "/cardspublic/balance");

    if (res.status === 200) {
      setData(res.data);
    } else if (res.status === 400) {
      console.log("error");
      setError(res.data.Errors[0]);
    }
    console.log(res);
  };

  return (
    <Container
      maxWidth="xs"
      id="home-container"
      className="d-flex flex-column justify-content-between align-items-center p-4"
    >
      <div>
        <img src={logo} alt="" />
      </div>

      <div
        id="form-container"
        className="d-flex flex-column justify-content-center p-4 my-5"
      >
        {error && (
          <Alert severity="error" className="mb-2" onClose={() => setError("")}>
            {error}
          </Alert>
        )}

        {data ? (
          <Amount
            amount={data.Amount}
            currency={data.Currency}
            setData={setData}
          />
        ) : (
          <FormBalance
            handleSubmit={handleSubmit}
            error={error}
            setError={setError}
          />
        )}
      </div>

      <Footer />
    </Container>
  );
};
